export enum AppIconType {

    Accessibility = "accessibility",
    AccessTime = "access-time",
    Account = "account",
    Add = "add",
    Applicatons = "apps",
    AspectRatio = "aspect-ratio",
    ArrowUp = "arrow-up",
    Back = "back",
    Bug = "bug",
    BusinessUnit = "business-unit",
    BubbleChart = "bubble-chart",
    Camera = "camera",
    Call = "call",
    CallEnd = "call-end",
    Chat = "chat",
    Check = "check",
    Clear = "clear",
    Close = "close",
    Cloud = "cloud",
    Create = "create",
    Code = "code",
    ChevronLeft = "chevron-left",
    Dashboard = "dashboard",
    DateRange = "daterange",
    Delete = "delete",
    LibraryBooks = "libraryBooks",
    Documents = "documents",
    Email = "email",
    EmailOutline = "email-outline",
    Favorite = "favorite",
    Feedback = "feedback",
    FilterList= "filterList",
    Finished = "finished",
    Fullscreen = "fullscreen",
    FullscreenExit = "fullscreen-exit",
    GroupWork = 'group-work',
    Home = "home",
    Help = "help",
    HelpLive = "help-live",
    InfoOutline = "info-outline",
    Icon = "icon",
    Mobile = "mobile",
    MobileOutline = "mobile-outline",
    Note = "note",
    LocalOffer = "localoffer",
    Lock = "lock",
    Logout = "logout",
    Menu = "menu",
    Notifications = "notifications",
    People = "people",
    PersonAdd = "person-add",
    Print = "print",
    Save = "save",
    Settings = "settings",
    Search = "search",
    Smiley = "smiley",
    Sms = "sms",
    Snapshot = "snapshot",
    Store = "store",
    Support = "support",
    ThumbDown = "thumbDown",
    ThumbUp = "thumbUp",
    Unfavorite = "unfavorite",
    Unlock  = "unlock",
    Update = "update",
    VisibilityOff = "visibility-off",
    VisibilityOn = 'visibility-on',
    Warning = "warning",
    Web = "web",
    Work = "work",
    ZoomOut = "zoom-out"
}
